export var ECollaboratorRole;
(function (ECollaboratorRole) {
    ECollaboratorRole["workshopAdmin"] = "Admin";
    ECollaboratorRole["editor"] = "Editor";
})(ECollaboratorRole || (ECollaboratorRole = {}));
export var ECollaboratorInviteRole;
(function (ECollaboratorInviteRole) {
    ECollaboratorInviteRole["Admin"] = "workshopAdmin";
    ECollaboratorInviteRole["Editor"] = "editor";
})(ECollaboratorInviteRole || (ECollaboratorInviteRole = {}));
//# sourceMappingURL=collaborator.js.map